<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="createNew()">Create {{serviceDisplayName}}</button>

    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search " + serviceDisplayName + "s"' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>

    <span *ngIf="hasSiteManagement" class="show-inactive-span">Show Inactive</span>
	<label *ngIf="hasSiteManagement" class="switch show-inactive-switch">
	<input
		id="showInactiveServices"
        type="checkbox" class="form-control"
        [(ngModel)]="showInactive"
		(change)="search();">
	<span class="slider round"></span>
    </label>
</div>
<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
</ngx-spinner>

<ngx-datatable #packageTable
               class='material striped datatable'
               [rows]='displayItems'
               [columnMode]='"force"'
               [headerHeight]='40'
               [footerHeight]='20'
               [scrollbarH]="true"
               [scrollbarV]="true"
               [rowHeight]="40"
               [reorderable]="true"
               [messages]='{emptyMessage:"No " + serviceDisplayName + "s to display here!"}'>

    <ngx-datatable-column prop="name" [sortable]="true" width="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                {{serviceDisplayName}} Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.name}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="createdBy" [sortable]="true" width="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Created By
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.createdBy}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="hasSiteManagement"  prop="modifiedBy" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Modified By / Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.modifiedBy ? row.modifiedBy : 'empty'}} / {{row.dateModified | date:'MM-d-y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="hasSiteManagement" prop="serviceId" [sortable]="true" width="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Service ID
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.serviceId}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="hasSiteManagement" prop="engineName" [sortable]="true" width="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Engine Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.engineName}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="file" [sortable]="false" >
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                {{serviceDisplayName}} File
            </span>
        </ng-template>
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template >
            <a *ngIf="row.active && !downloadStates[rowIndex + '-download'] || downloadStates[rowIndex + '-download'] === 0" (click)="checkDownloadLink(row, rowIndex)" download href="#">Download</a>
            <a *ngIf="!row.active" (click)="regenerate(row.id)" download href="#">Regenerate</a>
            <span *ngIf="downloadStates[rowIndex + '-download'] === 1 && downloadStates[rowIndex + '-downloadPercent'] === 0">Preparing download...</span>
            <span *ngIf="downloadStates[rowIndex + '-download'] === 1 && downloadStates[rowIndex + '-downloadPercent'] > 0">{{downloadStates[rowIndex + '-downloadPercent']}}%</span>
            <span *ngIf="downloadStates[rowIndex + '-download'] === 3">Complete</span>
            <span *ngIf="downloadStates[rowIndex + '-download'] === 4">Error</span>
       </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="startDate" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Start Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.startDate | date:'MM-d-y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="endDate" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                End Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.endDate | date:'MM-d-y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngFor="let col of additionalColumns" [prop]="col.propertyName" [sortable]="col.sortable">
            <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
                <span (click)="sort()" >
                    {{col.headerName}}
                </span>
            </ng-template>
            <ng-template let-row="row" ngx-datatable-cell-template >
                {{row[col.dataName]}}
            </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="hasSiteManagement" prop="active" [sortable]="true" width="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()" >
                Active
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template >
            {{row.active}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="130" [maxWidth]="130" >
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template let-row="row" class="action-row" ngx-datatable-cell-template >
            <button tooltip="Edit" class="btn btn-success btn-icon" (click)="edit(row.id, row.serviceId)"><i class="flaticon-edit-1"></i></button>
            <button tooltip="Delete" *ngIf="row.active" class="btn btn-danger btn-icon" (click)="delete(row.id)"><i class="flaticon-cancel"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>





